import { useEffect, useMemo, useState } from "react";
import { IdNameList } from "../../../api/services/common/models";
import {
  useGetClientBillingDetailsByClientId,
  useGetProgramFeeDetails,
} from "../../../api/services/program/programApis";

export const useGetProgramFeeConfig = () => {
  const [state, setState] = useState<{
    clientId: string;
    templateId: string;
  }>({
    clientId: "",
    templateId: "",
  });
  const {
    data: programFeeDetailsData,
    isFetching: isProgramFeeDetailsPending,
    isError: isProgramFeeDetailsError,
    isSuccess: isBillingDetailsGetApiSuccess,
    refetchWithParams: getProgramFeeByProgramId,
  } = useGetProgramFeeDetails();

  const {
    data: clientBillingDetails,
    isFetching: isClientBillingDetailsPending,
    isError: isClientBillingDetailsError,
    refetchWithParams: getClientBillingDetails,
  } = useGetClientBillingDetailsByClientId();

  const isLoading = useMemo(() => {
    return isProgramFeeDetailsPending || isClientBillingDetailsPending;
  }, [isProgramFeeDetailsPending, isClientBillingDetailsPending]);

  const isError = useMemo(() => {
    return isProgramFeeDetailsError || isClientBillingDetailsError;
  }, [isProgramFeeDetailsError, isClientBillingDetailsError]);

  useEffect(() => {
    if (programFeeDetailsData === null && isBillingDetailsGetApiSuccess) {
      getClientBillingDetails(state.clientId, state.templateId);
    }
  }, [programFeeDetailsData, isBillingDetailsGetApiSuccess]);

  const programFeeBillingCurrency = useMemo(() => {
    if (programFeeDetailsData || clientBillingDetails) {
      return (
        programFeeDetailsData?.currency ||
        (clientBillingDetails?.currency as IdNameList)
      );
    }
  }, [programFeeDetailsData, clientBillingDetails]);

  const fetchProgramFeeDetails = (
    programId: string,
    clientId: string,
    templateId: string,
  ) => {
    setState({ clientId, templateId });
    getProgramFeeByProgramId(programId);
  };

  return {
    isLoading,
    isError,
    programFeeBillingCurrency,
    fetchProgramFeeDetails,
  };
};
